import React, { Component } from 'react'
import styled from 'styled-components'
import { createBitlyLink } from '../../helpers'
import LinkTextBox from '../LinkTextBox/LinkTextBox'

const Wrapper = styled.div`
  margin-top: 200px;
  text-align: center;
`
class SocialBar extends Component {
  state = {
    showLink: false,
    bitlyLink: null
  }

  async handleLinkClick(e) {
    this.props.createUserEvent({
      category: 'navigation',
      data: { link_to: '#social', source: 'SocialLink' }
    })
    e.preventDefault()
    if (!this.state.showLink) {
      const bitlyLink = await createBitlyLink()
      this.setState({ bitlyLink })
    }
    this.setState({ showLink: !this.state.showLink })
  }

  render() {
    const { createUserEvent } = this.props

    return (
      <Wrapper>
        <div id="social-bar">
          <button
            className="ssk ssk-facebook ssk-db-icon  ssk-icon "
            onClick={() =>
              createUserEvent({
                category: 'navigation',
                data: { link_to: '#social', source: 'SocialFacebook' }
              })
            }
          />
          <button
            className="ssk ssk-twitter ssk-db-icon ssk-icon"
            onClick={() =>
              createUserEvent({
                category: 'navigation',
                data: { link_to: '#social', source: 'SocialTwitter' }
              })
            }
          />
          <button
            className="ssk ssk-google-plus ssk-db-icon ssk-icon"
            onClick={() =>
              createUserEvent({
                category: 'navigation',
                data: { link_to: '#social', source: 'SocialGoogle+' }
              })
            }
          />
          <button
            target="_blank"
            rel="noopener noreferrer"
            className="ssk ssk-email ssk-db-icon ssk-icon"
            onClick={() =>
              createUserEvent({
                category: 'navigation',
                data: { link_to: '#social', source: 'SocialEmail' }
              })
            }
          />
          <button
            className="ssk ssk-db-icon ssk-icon"
            onClick={this.handleLinkClick.bind(this)}
          >
            <span className="fa fa-link" />
          </button>
          <LinkTextBox show={this.state.showLink} text={this.state.bitlyLink} />
        </div>
      </Wrapper>
    )
  }
}

export default SocialBar



// WEBPACK FOOTER //
// ./src/components/SocialBar/SocialBar.js